import { LIQUID_BRACES_UNCLOSED_REGEXP, LIQUID_TAGS, LIQUID_TAGS_BROKEN_REGEXP } from '@client/enums/liquid-tags';

export const liquidLinter = (view) => {
  const doc = view.state.doc;
  const content = doc.toString();
  const diagnostics = [];

  let regex = LIQUID_BRACES_UNCLOSED_REGEXP;
  let match;

  while ((match = regex.exec(content)) !== null) {
    const lineInfo = doc.lineAt(match.index);

    diagnostics.push({
      from: match.index,
      to: match.index + match[0].length,
      line: lineInfo.number,
      severity: 'error',
      message: 'Unclosed Liquid tag or object.'
    });
  }

  regex = LIQUID_TAGS_BROKEN_REGEXP;

  while ((match = regex.exec(content)) !== null) {
    const lineInfo = doc.lineAt(match.index);

    if (!LIQUID_TAGS.includes(match[1])) {
      diagnostics.push({
        from: match.index,
        to: match.index + match[0].length,
        line: lineInfo.number,
        severity: 'error',
        message: `Unknown Liquid tag: ${match[1]}`
      });
    }
  }

  const event = new CustomEvent('liquidLintErrors', { detail: diagnostics });
  window.dispatchEvent(event);

  return diagnostics;
};
